module.exports = __webpack_public_path__ + "img/home.9aacb2cf.svg";